//login routing 
function view_group_login() {
  var $ = jQuery;
  // signout();
  if (!localStorage.getItem('ecw_customer_store_location_id')) {
    change_view('start-order');
  } else {
    $contentContainer
      .load(templateRoot + "wf-ordering-group-login.html", function () {
        window.scrollTo(0, 0);
        // Initialize Foundation
        $(document).foundation();

        activateSignIn($contentContainer.find("#punchh-login-form"));

        activateCreateGroupOrder($("#create-group-order-form"));
        activateInviteOthers($("#invite-others-to-group-order-form"));
        //
        if (localStorage.getItem('ecw_access_token') && localStorage.getItem('ecw_auth_token') && localStorage.getItem('ecw_customer_grouporderGuid') && localStorage.getItem('ecw_customer_basket_id')) {
          change_view('menu');
          console.log('invite others');
          $('#invite-others-to-group-order').foundation('open');
        } else if (localStorage.getItem('ecw_access_token') && localStorage.getItem('ecw_auth_token')) {
            console.log('create-group-order');

          $('#create-group-order').foundation('open');

          const guestEmail = localStorage.getItem('ecw_customer_guest_email');
          const guestFirstName = localStorage.getItem('ecw_customer_guest_first_name');
          const guestLastName = localStorage.getItem('ecw_customer_guest_last_name');

          if (guestEmail !== null && guestEmail !== undefined && guestEmail !== "undefined") {
            $('[data-users-email]').text(guestEmail);
          } else if (guestFirstName !== null && guestFirstName !== undefined && guestFirstName !== "undefined") {
            $('[data-users-email]').text(guestFirstName + ' ' + guestLastName);
          } else {
            $('[data-users-email]').text(localStorage.getItem('ecw_customer_username'));

          }
        }

      })
      .hide()
      .fadeIn(transitionDuration);
  }

}
function view_join_group_order() {
  var $ = jQuery;

  $contentContainer
    .load(templateRoot + "wf-ordering-group-join-order.html", function () {
      window.scrollTo(0, 0);
      let isSubmitting = false;
      $joinOrderFormItem = $contentContainer.find("#punchh-login-form");
      var loginFormAbide = new Foundation.Abide($joinOrderFormItem, {});

      $joinOrderFormItem.on("submit", function (e) {
        e.preventDefault();
      });
      //
      $joinOrderFormItem.on("formvalid.zf.abide", function (e, target) {
        // ecw_show_loading();
        e.preventDefault(); // prevent native submit
        if (isSubmitting) return; // block duplicate
        isSubmitting = true;

        // console.log('i try to submit');
        const route = window.location.href;

        let groupOrderId = null;
        if (route.includes("groupOrderID=")) {
          groupOrderId = route.split("groupOrderID=")[1].split(/[?&]/)[0];
          localStorage.setItem('ecw_customer_grouporderGuid', groupOrderId);
          // console.log("groupOrderId:", groupOrderId);
        }
        let storeId = null;
        if (route.includes("storeID=")) {
          storeId = route.split("storeID=")[1].split(/[?&]/)[0];
          // console.log("storeId:", storeId);
          localStorage.setItem('ecw_customer_store_location_id', storeId);
        }

        // console.log("groupOrderId", groupOrderId); 

        getGroupOrder().then(function (result) {
          // console.log("Result outside function:", result);

          isSubmitting = false;
          if (result.message) {
            formerrors = {
              base: result.message,
            };
            ecw_set_form_errors(formerrors, $joinOrderFormItem);
            localStorage.removeItem('ecw_customer_grouporderGuid');
            localStorage.removeItem('ecw_customer_basket_id');
            localStorage.removeItem('ecw_customer_group_order_name');
            localStorage.removeItem('ecw_customer_group_order_user_type');
            localStorage.removeItem('ecw_customer_host_group_order_name');

          } else {
            localStorage.setItem('ecw_customer_grouporderGuid', groupOrderId);
            localStorage.setItem('ecw_customer_basket_id', result.basket.id);
            localStorage.setItem('ecw_customer_group_order_name', $joinOrderFormItem.find("input#join_order_name").val());
            localStorage.setItem('ecw_customer_group_order_user_type', 'notHost');
            localStorage.setItem('ecw_customer_deliverymode', result.basket.deliverymode);
            localStorage.setItem('ecw_customer_store_phone', result.basket.contactnumber);

            // console.log("Result outside function:", result);
            // console.log("Result outside function:", result.basket.id);

            change_view("menu");

          }
        });
      });

    })
    .hide()
    .fadeIn(transitionDuration);


}


//
//now create group order 
function activateCreateGroupOrder($formItem) {
  var $ = jQuery;
  var loginFormAbide = new Foundation.Abide($formItem, {});

  //set min date 
  const punchhDeadlineInput = $formItem.find("input#punchh_deadline");
  // console.log('punchhDeadlineInput', punchhDeadlineInput);
  const now = new Date();

  now.setMinutes(now.getMinutes() + 30);

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');

  const futureDateTime = `${year}-${month}-${day}T${hour}:${minute}`;
  punchhDeadlineInput.attr('min', futureDateTime);
  //end of set min date

  $("#basketGuid").val(localStorage.getItem("ecw_customer_basket_id"));
  // console.log('i try to submit', $formItem);
  let isSubmitting = false;

  $formItem.on("submit", function (e) {
    e.preventDefault();
    // isSubmitting = true;
  });
  //
  $formItem.on("formvalid.zf.abide", function (e, target) {
    e.preventDefault(); // prevent native submit
    if (isSubmitting) return; // block duplicate
    isSubmitting = true;
    // console.log('i try to submit');
    // ecw_show_loading();

    // alert('valid');
    const deadlineVal = punchhDeadlineInput.val();

    if (deadlineVal) {
      const deadline = new Date(deadlineVal);
      const now = new Date();
      const minAllowed = new Date(now.getTime() + 30 * 60 * 1000); // now + 30 minutes

      if (deadline >= minAllowed) {

        const date = new Date(deadlineVal);

        const yyyy = date.getFullYear();
        const MM = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const HH = String(date.getHours()).padStart(2, "0");
        const mm = String(date.getMinutes()).padStart(2, "0");

        const formatted = `${yyyy}${MM}${dd} ${HH}:${mm}`;

        localStorage.setItem("ecw_customer_group_order_deadline", formatted);
      } else {
        formerrors = {
          base: "Deadline is required and must be at least 30 minutes in the future.",
        };
        ecw_set_form_errors(formerrors, $formItem);
      }
      //create basket if there isnt a basket
      if (!localStorage.getItem("ecw_customer_basket_id")) {
        olo_create_basket(
          localStorage.getItem("ecw_customer_store_location_id"),
          false,
          true
        )
      }
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "olo_create_group_host_order",
          authtoken: localStorage.getItem('ecw_auth_token'),
          restaurantid: localStorage.getItem('ecw_customer_store_location_id'),
          basketid: localStorage.getItem('ecw_customer_basket_id'),
          deadline: localStorage.getItem("ecw_customer_group_order_deadline"),
          referer: window.location.href,
        },
        success: function (response) {
          var result = JSON.parse(response);

          console.log('response', result);
          if (result.code) {
            formerrors = {
              base: result.message,
            };
            ecw_set_form_errors(formerrors, $formItem);
            if (result && result.code === 14) {
              if (localStorage.getItem('ecw_customer_grouporderGuid')) {
                localStorage.setItem('ecw_customer_group_order_user_type', 'host');

                change_view("menu");
                $('#create-group-order').foundation('close');
              } else {
                alert('We are sorry. Something went wrong');
                localStorage.removeItem('ecw_customer_grouporderGuid');
                localStorage.removeItem('ecw_customer_basket_id');
                localStorage.removeItem('ecw_customer_group_order_name');
                localStorage.removeItem('ecw_customer_group_order_user_type');
                localStorage.removeItem('ecw_customer_host_group_order_name');
                clearBasketSession();
              }
              // console.log('asdgasdg');


            }
          } else {
            console.log("Success:", result);
            localStorage.setItem('ecw_customer_grouporderGuid', result.id);
            localStorage.setItem('ecw_customer_group_order_user_type', 'host');

            change_view("menu");
            $('#invite-others-to-group-order').foundation('open');

          }
        }
      });
    } else {
      formerrors = {
        base: "Deadline is required and must be at least 30 minutes in the future.",
      };
      ecw_set_form_errors(formerrors, $formItem);
    }

  });



}
function activateInviteOthers($formItem) {
  var $ = jQuery;
  var loginFormAbide = new Foundation.Abide($formItem, {});

  $("#grouporderGuid").val(localStorage.getItem("ecw_customer_grouporderGuid"));
  // //
  // const domainName = window.location.hostname;
  // const prefix = domainName.startsWith('www.') ? 'https://' : 'https://www.';

  //   let inviteUrl = prefix + domainName + '/order/#group-order/join?groupOrderID=' + localStorage.getItem("ecw_customer_grouporderGuid") + '?storeID=' + localStorage.getItem("ecw_customer_store_location_id");
  //   console.log('inviteUrl', inviteUrl);
  // console.log('i try to submit', $formItem);
  let isSubmitting = false;

  $formItem.on("submit", function (e) {
    e.preventDefault();
    isSubmitting = true;
  });
  //
  $formItem.on("formvalid.zf.abide", function (e, target) {
    if (isSubmitting) return; // block duplicate
    isSubmitting = true;
    // console.log('i try to submit');
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_send_group_order_invites",
        groupOrderGuid: localStorage.getItem('ecw_customer_grouporderGuid'),
        authtoken: localStorage.getItem('ecw_auth_token'),
        emailaddress: $("#invite-others-to-group-order-form").find('input#invitee_email').val(),
        referer: window.location.href,

      },
      success: function (response) {
        let result = JSON.parse(response);

        if (result.code && result.code != 200) {
          formerrors = {
            base: "Something went wrong. Please try again.",
          };
          ecw_set_form_errors(formerrors, $formItem);
        } else {
          // Initialize Foundation
          $(document).foundation();

          $('#invite-others-to-group-order').foundation('close');
          $('#invite-others-to-group-order-success').foundation('open');
        }



      }
    });
  });



}
var $ = jQuery;
//
function lockGroupOrder(lockGroupOrder) {
  var $ = jQuery;

  // console.log('i locks', lockGroupOrder);
  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_lock_group_order",
      groupOrderGuid: localStorage.getItem('ecw_customer_grouporderGuid'),
      authtoken: localStorage.getItem('ecw_auth_token'),
      lockGroupOrder: lockGroupOrder,
      referer: window.location.href,

    },
    success: function (response) {
      let result = JSON.parse(response);
      if (result.status === "locked" || result.status === "created") {
        // console.log('olo_lock_group_order', result);

      } else {
        alert("Something went wrong.");
      }
    }
  });
}
function cancelGroupOrder() {
  var $ = jQuery;
  ecw_show_loading();

  // console.log('cancelGroupOrder', localStorage.getItem('ecw_customer_grouporderGuid'), localStorage.getItem('ecw_auth_token'));
  //cancel order
  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_cancel_group_order",
      groupOrderGuid: localStorage.getItem('ecw_customer_grouporderGuid'),
      authtoken: localStorage.getItem('ecw_auth_token'),
      referer: window.location.href,

    },
    success: function (response) {
      var cancel_result = JSON.parse(response);
      console.log('cancel_result', cancel_result);
      if (cancel_result.status == "cancelled" || cancel_result.code == 200) {
        localStorage.removeItem('ecw_customer_grouporderGuid');
        localStorage.removeItem('ecw_customer_basket_id');
        localStorage.removeItem('ecw_customer_group_order_deadline');
        localStorage.removeItem('ecw_customer_group_order_name');
        localStorage.removeItem('ecw_customer_group_order_user_type');
        localStorage.removeItem('ecw_customer_host_group_order_name');

        window.location.reload();
        ecw_hide_loading();

      } else {
        // console.log('cancel_result', cancel_result);
        // alert('Something went wrong. Please try again. Error message: ' + cancel_result);
        localStorage.removeItem('ecw_customer_grouporderGuid');
        localStorage.removeItem('ecw_customer_basket_id');
        localStorage.removeItem('ecw_customer_group_order_deadline');
        localStorage.removeItem('ecw_customer_group_order_name');
        localStorage.removeItem('ecw_customer_group_order_user_type');
        localStorage.removeItem('ecw_customer_host_group_order_name');
        window.location.reload();
        ecw_hide_loading();

      }
    },
  });

  $('#cancel-order').foundation('close');

}

function getGroupOrder() {
  // console.log('i trigger getGroupOrder', localStorage.getItem('ecw_customer_grouporderGuid'));
  return jQuery.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_group_order",
      groupOrderGuid: localStorage.getItem('ecw_customer_grouporderGuid'),
      referer: window.location.href,

    },
  }).then(function (response) {
    let result = JSON.parse(response);
    // console.log("olo_get_group_order", result);
    return result;
  });
}

function leaveGroupOrder() {
  localStorage.removeItem('ecw_customer_grouporderGuid');
  localStorage.removeItem('ecw_customer_basket_id');
  localStorage.removeItem('ecw_customer_group_order_name');
  localStorage.removeItem('ecw_customer_group_order_user_type');
  localStorage.removeItem('ecw_customer_host_group_order_name');

  window.location.reload();
}